import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	width: 100%;
	padding: 16px 0;

	h2 {
		padding: 24px 0;
		color: ${tokens.color_gray_dark};
		font-size: 18px;
		font-weight: 600;
	}
`;
